module.exports = __webpack_public_path__ + "static/articulo2-2b92bddc37fb6062fa57caa8310ff7a1.png";